// extracted by mini-css-extract-plugin
export default {"content":"Terms_content__a4s13","link":"Terms_link__HFt2W","liTextPrivacyPolicy":"Terms_liTextPrivacyPolicy__fMNsP"};